import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";

/**
 * Renders text translated to current language.
 * cacheKey should be stable/unique (e.g. `prop:<id>:title`).
 */
export const TText = ({ text, cacheKey, as = "span", className = "", ...rest }) => {
  const { lang, translate } = useLanguage();
  const [out, setOut] = useState(text);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!text) { setOut(""); return; }
    if (lang === "es") { setOut(text); return; }
    setLoading(true);
    translate(text, cacheKey).then((r) => {
      if (!cancelled) { setOut(r); setLoading(false); }
    });
    return () => { cancelled = true; };
  }, [text, lang, cacheKey, translate]);

  const Tag = as;
  return <Tag className={`${className} ${loading ? "opacity-60" : ""}`} {...rest}>{out}</Tag>;
};
